import React, { Component } from 'react';
import styled from 'styled-components';

import Page from 'components/Page';
import Container from 'components/Container';
import Form from './elements/Form/Form';

class Register extends Component {
  render() { 
    return (
      <Page
        background={require('src/assets/images/home/bg.jpg')}
        transparent
      >
        <Root>
          <Container>
            <Form/>
          </Container>
        </Root>
      </Page>
    );
  }
}

const Root = styled.div`
  padding-top: 202px;
  padding-bottom: 100px;
`;
 
export default Register;


// WEBPACK FOOTER //
// ./src/pages/Register/Register.js